// extracted by mini-css-extract-plugin
module.exports = {"hyperText":"Ship_hyperText__2r5ZV","pointer":"Ship_pointer__mCCQh"};